import React from 'react';
import PropTypes from 'prop-types';
import ListContainer from '../../containers/ListContainer';
import listTypes from './listTypes';
import { ALL_DAY } from '../../../../../ui-kitchen/src/constants/resyCore';

const { BOOK_TONIGHT, RECOMMENDATIONS } = listTypes;

const PersonalizedList = (props) => {
  const {
    $rootScope,
    Analytics,
    Analytics: { event },
    getRecommendations,
    getBookTonight,
    badge,
    collectionSlug,
    isAuthenticated,
    isMobile,
    latLng,
    loadNotifyModal,
    locationCode,
    locationSlug,
    name,
    nameTranslationKey,
    selectedDate,
    selectedTime,
    selectedSeats,
    showSeeMore,
    type,
    bookTonightVenues,
    recommendedVenues,
    bookTonightVenuesIsLoading,
    recommendedVenuesIsLoading,
    showAuthModal,
    favoriteVenueIds,
    matchMedia,
  } = props;

  const mapTypeToAPI = {
    [BOOK_TONIGHT]: getBookTonight,
    [RECOMMENDATIONS]: getRecommendations,
  };

  const mapTypeToData = {
    [BOOK_TONIGHT]: bookTonightVenues,
    [RECOMMENDATIONS]: recommendedVenues,
  };

  const mapTypeToLoadingState = {
    [BOOK_TONIGHT]: bookTonightVenuesIsLoading,
    [RECOMMENDATIONS]: recommendedVenuesIsLoading,
  };

  const getVenueAPI = mapTypeToAPI[type];
  const getVenues = mapTypeToData[type];
  const isLoading = mapTypeToLoadingState[type];

  if (!isAuthenticated && type === RECOMMENDATIONS) return null;

  return (
    <ListContainer
      Analytics={Analytics}
      $rootScope={$rootScope}
      badge={badge}
      collectionSlug={collectionSlug}
      event={event}
      favoriteVenueIds={favoriteVenueIds}
      getVenues={getVenueAPI}
      isLoading={isLoading}
      isMobile={isMobile}
      latLng={latLng}
      loadNotifyModal={loadNotifyModal}
      locationCode={locationCode}
      locationSlug={locationSlug}
      name={name}
      nameTranslationKey={nameTranslationKey}
      selectedDate={selectedDate}
      selectedTime={selectedTime}
      selectedSeats={selectedSeats}
      showAuthModal={showAuthModal}
      showSeeMore={showSeeMore}
      type={type}
      venues={getVenues}
      matchMedia={matchMedia}
    />
  );
};

const personalizedListPropTypes = {
  $rootScope: PropTypes.shape(PropTypes.object.isRequired).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  collectionSlug: PropTypes.string,
  favoriteVenueIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  getRecommendations: PropTypes.func,
  getBookTonight: PropTypes.func,
  loadNotifyModal: PropTypes.func.isRequired,
  locationCode: PropTypes.string,
  locationSlug: PropTypes.string,
  type: PropTypes.string,
  badge: PropTypes.string,
  isAuthenticated: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool,
  latLng: PropTypes.shape({
    value: PropTypes.string,
  }),
  name: PropTypes.string,
  nameTranslationKey: PropTypes.string,
  selectedDate: PropTypes.string.isRequired,
  selectedTime: PropTypes.string,
  selectedSeats: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  showAuthModal: PropTypes.func.isRequired,
  showSeeMore: PropTypes.bool,
  bookTonightVenues: PropTypes.arrayOf(PropTypes.object),
  recommendedVenues: PropTypes.arrayOf(PropTypes.object),
  recommendedVenuesIsLoading: PropTypes.bool.isRequired,
  bookTonightVenuesIsLoading: PropTypes.bool.isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
};

PersonalizedList.defaultProps = {
  type: BOOK_TONIGHT,
  badge: '',
  collectionSlug: undefined,
  getRecommendations: null,
  getBookTonight: null,
  isMobile: false,
  latLng: null,
  locationCode: 'ny',
  locationSlug: 'new-york-ny',
  name: '',
  selectedSeats: 2,
  selectedTime: ALL_DAY,
  nameTranslationKey: undefined,
  showSeeMore: undefined,
  bookTonightVenues: [],
  recommendedVenues: [],
};

PersonalizedList.propTypes = personalizedListPropTypes;
PersonalizedList.displayName = 'PersonalizedList';

export { personalizedListPropTypes };
export default PersonalizedList;
